import React, { useEffect, useRef } from 'react';
import c from './error-page.module.scss';
import { Topnav, TopnavContainer } from '@monash/portal-react';
import errorAnimation from '../../assets/lotties/error.json';
import AppLauncherPad from '../app-launcher/AppLauncherPad';
import RenderAnimation from '../../components/render-animation/RenderAnimation';
import MaintenanceIllustration from './MaintenanceIllustration';

const defaultContent = {
  title: 'Sorry, we’re facing technical difficulties.',
  message:
    'Oh no! it looks like the page you’re trying to reach is on a study break. Please try again later.',
};

const ErrorPage = ({
  navTitle,
  userMenu,
  title,
  message,
  action,
  userType,
  inMaintenance,
}) => {
  const errorPageRef = useRef();
  useEffect(() => {
    errorPageRef.current.focus();
  }, []);

  const displayTitle =
    (inMaintenance.enabled && 'System maintenance') ||
    title ||
    defaultContent.title;

  const displayMessage =
    inMaintenance.message || message || defaultContent.message;

  const graphic = inMaintenance.enabled ? (
    <div className={c.image}>
      <MaintenanceIllustration.Desktop />
    </div>
  ) : (
    <RenderAnimation
      className={c.animationWidth}
      aspectRatio="xMaxYMin"
      lottieFile={errorAnimation}
      loop={true}
    />
  );
  return (
    <TopnavContainer>
      <Topnav title={navTitle} menu={false}>
        <div>
          <AppLauncherPad type={userType} />
          {userMenu}
        </div>
      </Topnav>
      <div className={c.errorPage} tabIndex={-1} ref={errorPageRef}>
        <div className={c.animationWidth}>
          {graphic}

          <h1 className={c.title}>{displayTitle}</h1>

          <div className={c.message}>{displayMessage}</div>
          <div className={c.cta}>{action && action}</div>
        </div>
      </div>
    </TopnavContainer>
  );
};

export default ErrorPage;
